// Import React
import React from "react";

// Importa tus imágenes (ejemplo con assets locales)
import visa from "../assets/payments-methods/visa.png";
import mastercard from "../assets/payments-methods/master.png";
import oca from "../assets/payments-methods/oca.png";
import redpagos from "../assets/payments-methods/redpagos.png";
import abitab from "../assets/payments-methods/abitab.png";
import mercadopago from "../assets/payments-methods/mercadopago.png";

const PaymentMethods = () => {
  const methods = [visa, mastercard, oca, redpagos, abitab, mercadopago];

  return (
    <div className="flex gap-3 items-center my-12 flex-wrap">
      {methods.map((method, index) => (
        <img
          key={index}
          src={method}
          alt={`Método de pago ${index}`}
          className="object-contain w-10 md:w-[70px]" 
        />
      ))}
    </div>
  );
};

// Export PaymentMethods Component
export default PaymentMethods;